import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedData } from '../models/BaseResponse';
import { Guardian } from '../models/Guardian';
import { GuardianSearchCriteria } from '../models/searchCriteria/GuardianSearchCriteria';

@Injectable({
  providedIn: 'root'
})
export class GuardianService {


  constructor(private httpClient: HttpClient) { }

  find(searchCriteria: GuardianSearchCriteria): Observable<PagedData<Guardian>> {
    return this.httpClient.post<PagedData<Guardian>>(environment.apiUrl + "guardians/filtered", searchCriteria);
  }

  get(id: number): Observable<Guardian> {
    return this.httpClient.get<Guardian>(environment.apiUrl + "guardians/" + id);
  }

  save(guardian: Guardian): Observable<void> {
    return this.httpClient.post<void>(environment.apiUrl + "guardians", guardian);
  }

  delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(environment.apiUrl + "guardians/" + id);
  }
}
